import React from "react";
import "./OnboardingMobileSupportInfo.less";
import { Button, Heading } from "@telia/teddy";
import { trackWebshopClickEvent } from "../../../../google-analytics/googleAnalyticsEventHelper";

interface OnboardingMobileSupportProps {
    setShowModal: (show: boolean) => void;
}

const OnboardingMobileSupportInfo: React.FC<OnboardingMobileSupportProps> = ({ setShowModal }) => {
    function buttonOnClick(): void {
        trackWebshopClickEvent({
            action: "click",
            text: "Vis starthjelp",
            type: "button",
            url: "/kasse/oppsummering",
            context: "display_starthjelp_options",
        });
        setShowModal(true);
    }

    return (
        <div className="onboarding-mobile-support-info">
            <Heading as="h3" variant="title-100">
                Trenger du starthjelp?
            </Heading>
            <div className="onboarding-mobile-support-info--infotext">
                Vi gjør den nye mobilen din klar til bruk når du henter i butikk.
            </div>
            <div className="onboarding-mobile-support-info--button">
                <Button onClick={(): void => buttonOnClick()}>Se hva vi kan hjelpe deg med</Button>
            </div>
        </div>
    );
};

export default OnboardingMobileSupportInfo;
